import React from 'react';
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Event } from "../../../../Helper";

export default class Footer extends React.Component {

    userAgreement = () => {
        Event.emit('show_agreement');
    }

    privacyPolicy = () => {
        Event.emit('show_privacy');
    }

    verify = () => {
        Event.emit('show_verify');
    }

    render() {
        const { t } = this.props;
        const currentYear = new Date().getFullYear();

        return (
            <footer className="footer-container">
                <div className="footer-content">
                    <Row className="justify-content-center text-center">
                        <Col lg={6} md={8} className="footer-contact-section">
                            {/* <h5 className="footer-heading">Contact Us</h5> */}
                            <div className="d-flex justify-content-center">
                                <div className="contact-item mx-1">
                                    <i className="mdi mdi-phone"></i>
                                    <a href="tel:254703903203">Call Us: 0703903203</a>
                                </div>
                                <div className="contact-item mx-1">
                                    <i className="mdi mdi-whatsapp"></i>
                                    <a href="https://wa.me/254703903203" target="_blank" rel="noopener noreferrer">WhatsApp Support</a>
                                </div>
                            </div>
                            {/* <div className="social-links mt-4 justify-content-center">
                                <a href="https://wa.me/254703903203" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
                                    <i className="mdi mdi-whatsapp"></i>
                                </a>
                                <a href="#" className="social-icon facebook">
                                    <i className="mdi mdi-facebook"></i>
                                </a>
                                <a href="#" className="social-icon twitter">
                                    <i className="mdi mdi-twitter"></i>
                                </a>
                                <a href="#" className="social-icon telegram">
                                    <i className="mdi mdi-telegram"></i>
                                </a>
                            </div> */}
                        </Col>
                    </Row>
                </div>

                <div className="footer-bottom">
                    <Row className="align-items-center">
                        <Col md={12} className="text-center text-md-start">
                            <p className="copyright-text mb-2">
                                FastaFX is a CFD (Contract for Difference) is a leveraged financial derivative that allows traders to speculate on the price movement of assets—like stocks, forex, commodities, or indices—without owning them. You profit from the difference between the entry and exit price, enabling both long (rising) and short (falling) positions; it is basically a binary.
                            </p>
                            <p className="copyright-text mb-2">
                                FastaFX is regulated in several countries and licensed To ensure liquidity and available prices, the trading platform utilizes a market maker service, the functions of which are performed by FastaFX LTD, company number 5896321, registered in Seychelles to operate in East Africa.
                            </p>
                            <p className="copyright-text mb-md-0">
                                &copy; {currentYear} <span className="fw-bold">FastaFX</span>. All rights reserved.
                            </p>
                        </Col>
                        {/* <Col md={6} className="text-center text-md-end">
                            <div className="payment-icons">
                                <span className="payment-label">Secure Payments via M-PESA</span>
                            </div>
                        </Col> */}
                    </Row>
                </div>
            </footer>
        );
    }
}
